import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=6f777c6e&scoped=true&"
import script from "./Tester.vue?vue&type=script&lang=js&"
export * from "./Tester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f777c6e",
  null
  
)

export default component.exports